import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import CommonImage from '@components/CommonImage';

import { clearDesignViewModalInfo, setDesignViewModalInfo } from '@store/actions/DesignViewModalAction';

import { isSetProduct } from '@/utils/Util';

const StyleDraftBoard = ({
	onClose,
	products = [],
	totalDraft,
	unDraftProduct,
	removeDraftProduct,
	parentComponent,
	onUnLike
}) => {
	const [allProducts, setAllProducts] = useState([]);
	const dispatch = useDispatch();

	useEffect(() => {
		setAllProducts(products);
	}, [products]);

	const onSearchItem = (event) => {
		const searchValue = event.target.value.trim().toLowerCase();

		if (!searchValue) {
			setAllProducts(products);
			return;
		}

		setAllProducts(() => {
			if (searchValue === '') {
				return allProducts;
			}
			return products.filter((item) => {
				const normalizedReferenceNumber = item.referenceNumber.toLowerCase();
				return normalizedReferenceNumber.includes(searchValue);
			});
		});
	};

	const onCloseViewModal = async () => {
		dispatch(clearDesignViewModalInfo({}));
	};

	const handleOpenTechpack = (item, isSet = false) => {
		dispatch(
			setDesignViewModalInfo({
				mergeProductList: item?.setMemberProductIds || [],
				isShowMergeTechPack: isSet,
				id: item.id,
				onCloseViewModal: () => onCloseViewModal(),
				isDefaultOpenBasicInfo: true
			})
		);
	};

	const renderActionButtons = (item) => {
		return (
			<>
				{parentComponent === 'FAVOURITE_DETAILS' ? (
					<div className="style-action favourite-style-action">
						<CommonImage
							src="/icons/favorite.svg"
							alt="favourite"
							class="add-to-favorite cursor-pointer"
							onClick={(e) => {
								e.stopPropagation();
								onUnLike(item?.id);
							}}
						/>
					</div>
				) : (
					<div
						className="style-action"
						onClick={(e) => {
							e.stopPropagation();
							removeDraftProduct(item);
						}}
					>
						<CommonImage src="/icons/delete_gray.svg" alt="delete" className="cursor-pointer" />
					</div>
				)}
			</>
		);
	};

	const renderProducts = () => {
		return allProducts?.map((item) => (
			<div key={`draft_card_${item.id}`}>
				{isSetProduct(item) ? (
					<div
						className="single-card-item with-editable set cursor-pointer"
						onClick={() => handleOpenTechpack(item, true)}
					>
						<div className="set-image-layout">
							<CommonImage
								src={item?.designDocuments?.[0]?.docUrl}
								alt="set"
								isStatic={false}
							/>
							<CommonImage
								src={item?.designDocuments?.[1]?.docUrl}
								alt="set"
								isStatic={false}
							/>
						</div>
						{renderActionButtons(item)}
						<button
							class="button secondary size32 plus-btn cursor-pointer"
							onClick={(e) => {
								e.stopPropagation();
								unDraftProduct(item);
							}}
						>
							<CommonImage src="/icons/plus-20.svg" />
						</button>
						<div className="set-status">
							<span className="status set">set</span>
						</div>
					</div>
				) : (
					<div className="single-card-item cursor-pointer" onClick={() => handleOpenTechpack(item)}>
						<div className="style-photo">
							<CommonImage
								src={item?.designDocuments?.[0]?.docUrl}
								alt="design"
								className="design-image"
								isStatic={false}
							/>
						</div>
						{renderActionButtons(item)}
						<button
							className="button secondary size32 plus-btn"
							onClick={(e) => {
								e.stopPropagation();
								unDraftProduct(item);
							}}
						>
							<CommonImage src="/icons/plus-20.svg" alt="plus" />
						</button>
					</div>
				)}

				<span className="title-number semibold-12">{item.referenceNumber}</span>
			</div>
		));
	};

	return (
		<div className="draft-board px-3 scroll-y-label">
			<div className="draft-board-header py-4">
				<div className="d-flex justify-content-between align-items-center">
					<h3 className="regular-14 weight-700 mb-0">Draft Board</h3>
					<CommonImage
						src="/icons/close.svg"
						alt="close"
						className="cursor-pointer"
						onClick={onClose}
					/>
				</div>
				<div className="with-icon left-icon mt-2">
					<span className="left-icon">
						<CommonImage src="/icons/search.png" alt="search" />
					</span>
					<input
						type="text"
						autoComplete="off"
						placeholder={'Design number'}
						onChange={onSearchItem}
					/>
				</div>

				<p className="regular-14 gray_dark_01 mt-2">
					{totalDraft > 0 && (
						<>
							Total: <span className="weight-500">{allProducts.length || 0}</span>
						</>
					)}
				</p>
			</div>
			<div className="draft-board-body pb-4">
				<div className="all-designs">{renderProducts()}</div>
			</div>
		</div>
	);
};

export default StyleDraftBoard;
